(function () {
    'use strict';

    angular
        .module('app')
        .directive('multisearchSelect', multisearchSelect);

    multisearchSelect.$inject = ['$window', '$filter', '$timeout'];

    function multisearchSelect($window, $filter, $timeout) {
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/multifieldsearch/templates/multisearchselect.html',
            scope: {
                selectedItem: "=?",
                getData: "&",
                items: "=?",
                csDisabled: "=?",
                modelChanged: "=?",
                allowText: "=?",
                selectId: "=?",
                groupModel: "=?",
                searchGroups: "=?",
                controlIndex: "=?"
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.text = "";
            scope.placeHolder = "";
            scope.items = [];
            scope.currentItems = scope.items;
            scope.allItemsCache = [];
            scope.loading = false;
            //get the dropdown element to user for scrolling later.
            var dropdown = element[0].getElementsByClassName('dropdown-list');

            scope.itemSelected = function (item) {
                scope.selectedItem = item.displayName;
                scope.groupModel.field = item.schemaID;
                scope.inputChanged();
                scope.show = '';
                scope.showClear = false;
            }

            var selectedItem = -1;
            var dropdown = angular.element(element[0].querySelector('#myDropdown'));
            element.bind('keydown', function (e) {


                switch (e.keyCode) {
                    case 38:
                        if (selectedItem > -1) {
                            scope.currentItems[selectedItem].selected = false;
                        }
                        if (selectedItem > 0) {
                            selectedItem = selectedItem - 1;
                            scope.currentItems[selectedItem].selected = true;

                            var offSet = selectedItem * 30; //TODO: calculate based on height of element
                            dropdown[0].scrollTop = offSet;
                            scope.$apply();
                        }

                        break;
                    case 40:
                        if (selectedItem > -1) {
                            scope.currentItems[selectedItem].selected = false;
                        }
                        if (selectedItem < scope.currentItems.length - 1) {
                            selectedItem = selectedItem + 1;
                            scope.currentItems[selectedItem].selected = true;

                            var offSet = selectedItem * 30; //TODO: calculate based on height of element
                            dropdown[0].scrollTop = offSet;
                            scope.$apply();
                        }
                        break;
                    case 13:
                    case 9:
                        if (scope.show == "show" || e.keyCode == 9) {
                            var item = $filter('filter')(scope.currentItems, { selected: true });
                            if (item.length > 0) {
                                scope.itemSelected(item[0]);
                                scope.showClear = true;
                                scope.$apply();
                            }
                            return false;
                        }

                    default:
                }
            });


            scope.inputFocus = function () {
                selectedItem = -1;
                $timeout(function () {
                    dropdown[0].scrollTop = 0;
                },200)
                
                if (scope.selectedItem) {
                    scope.showClear = true;
                }
                else {
                    scope.showClear = false;
                }
                scope.showToggle();
            }

            scope.clearSelected = function (item) {
                scope.groupModel.field = "";
                scope.selectedItem = "";
                scope.show = false;
                scope.inputChanged();
            }

            scope.inputChanged = function () {
                scope.show = 'show';
                if (scope.selectedItem || scope.selectedItem != "") {
                    scope.showClear = true;
                }
                else {
                    scope.showClear = false;
                }
                var filtered = $filter('filter')(scope.items, scope.selectedItem);
                scope.currentItems = filtered;
                scope.modelChanged(scope.groupModel);
            }

            var inputSearch = element[0].getElementsByClassName('select-input');
            var input = angular.element(inputSearch);
            input.on('keydown', function (e) {
                if (e.keyCode == 9) {
                    scope.show = '';
                }
            });

            scope.inputBlur = function () {
                $timeout(function () {
                    scope.showClear = false;
                }, 200);

                if (scope.selectedItem == "") {
                    return;
                }

                if (!scope.allowText) {
                    var item = $filter('filter')(scope.items, scope.selectedItem);
                    if (item.length > 0) {
                        scope.selectedItem = item[0].displayName;
                        scope.groupModel.field = item.schemaID;
                        scope.modelChanged(scope.groupModel);
                    }
                    else {
                        scope.selectedItem = "";
                    }
                }

            }

            scope.showToggle = function () {
                
                if (!scope.csDisabled) {
                    $timeout(function () {
                        dropdown.scrollTop = 0;
                    }, 200)
                    scope.showList();
                    scope.currentItems = scope.items;

                    scope.loading = true;
                    scope.getData().then(function (items) {
                        scope.loading = false;

                        //remove SCHEMA_S_VERSION
                        items = $filter('filter')(items, function (item) {
                            if (item.schemaID == "SCHEMA_S_VERSION") {
                                return false;
                            }
                            return true;
                        });

                        angular.forEach(items, function (item) {
                            item.selected = false;
                        });

                        scope.items = items;
                        scope.allItemsCache = angular.copy(items);

                        scope.currentItems = $filter('filter')(scope.allItemsCache, function (item) {
                            var current = item;
                            var found = false;
                            angular.forEach(scope.searchGroups, function (item, key) {
                                if (item.field == current.schemaID) {
                                    found = true;
                                }
                            });
                            return !found;
                        });
                    })


                }
            }

            scope.showList = function () {
                dropdown[0].scrollTop = 0;
                selectedItem = -1;
                var w = angular.element($window);
                w.bind('click', windowBind);
                if (scope.show != 'show') {
                    scope.show = 'show'
                }
                else {
                    scope.show = '';
                }
            }

            var windowBind = function (e) {
                try {
                    if (!e.target.classList.contains('selectelem')) {
                        var w = angular.element($window);
                        w.off('click', windowBind);
                        scope.show = '';
                        scope.$apply();
                    }
                } catch (e) {

                }
            }
        }

    }

})();